"use client";

import { IconShare } from "@repo/assets/images";
import { useTrackShareProduct } from "@repo/lib/hooks/webengage";
import { useTranslations } from "next-intl";
const ShareProductButton = ({
  categorySlug,
  locale,
  product,
  canonicalUrl
}) => {
  const t = useTranslations("Common");
  const {
    trackShareProductEvent
  } = useTrackShareProduct();
  const {
    name,
    slug
  } = product;
  const shareUrl = `${canonicalUrl}/${locale}${categorySlug ? `/collections/${categorySlug}/products/${slug}` : `/${slug}`}`;
  const shareData = {
    title: name,
    text: `Check out this product: ${name}`,
    url: shareUrl
  };
  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share(shareData);
        console.log("Product shared successfully");
        trackShareProductEvent(product);
      } catch (error) {
        console.error("Error sharing product:", error);
      }
    }
  };
  if (!slug || !canonicalUrl) return null;
  return <button type="button" className="border-shareButton-border bg-shareButton-bg text-shareButton-icon me-8 block rounded-full border p-2 active:shadow-md md:hidden" onClick={handleShare} aria-label="share-product" title="Share Product" data-sentry-component="ShareProductButton" data-sentry-source-file="ShareProductButton.jsx">
      <IconShare data-sentry-element="IconShare" data-sentry-source-file="ShareProductButton.jsx" />
    </button>;
};
export default ShareProductButton;